'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toString = [].toString;
var hasOwn = Object.prototype.hasOwnProperty;
var types = {
  '[object Boolean]': 'bool',
  '[object Number]': 'number',
  '[object String]': 'string',
  '[object Object]': 'object',
  '[object Array]': 'array',
  '[object Function]': 'function',
  '[object Date]': 'date',
  '[object RegExp]': 'regExp'
};
var type = function type(obj) {
  return obj === null ? String(obj) : types[toString.call(obj)] || 'object';
};
var isWindow = function isWindow(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && 'setInterval' in obj;
};
var isArray = Array.isArray || function (obj) {
  return type(obj) === 'array';
};

var isPlainObject = function isPlainObject(obj) {
  if (!obj || type(obj) !== 'object' || isWindow(obj) || obj.nodeType) {
    return false;
  }
  try {
    if (obj.constructor && !hasOwn.call(obj, 'constructor') && !hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
      return false;
    }
  } catch (e) {
    return false;
  }
  var key = void 0;
  // eslint-disable-next-line
  for (key in obj) {}
  return key === undefined || hasOwn.call(obj, key);
};

exports.isPlainObject = isPlainObject;
exports.isArray = isArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kryfe/divolte/es/utils/index.js
// module id = 246
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 70 71